/**
 * Tab-lifetime (memory only) snapshot of ChatPage's project list, keyed by the
 * org id it was fetched for. A ChatPage remount (Skill Center / profile / org
 * pages -> back to chat) starts from it instead of an empty sidebar; ChatPage
 * still revalidates on mount. Cleared on logout through
 * `useConversation.ts::resetConversationDetailCache` (per-user data).
 *
 * Kept out of useConversation.ts so the many ChatPage tests that mock that hook
 * module wholesale do not have to re-declare these helpers.
 */
let projectListSnapshot: { orgId: string | null; projects: unknown[] } | null = null;

/** Last project list fetched for ``orgId``; null on a miss or an empty list. */
export function peekProjectListSnapshot<T>(orgId: string | null): T[] | null {
  if (!projectListSnapshot || projectListSnapshot.orgId !== orgId) return null;
  if (projectListSnapshot.projects.length === 0) return null;
  return projectListSnapshot.projects as T[];
}

export function storeProjectListSnapshot<T>(orgId: string | null, projects: T[]): void {
  projectListSnapshot = { orgId, projects };
}

export function resetProjectListSnapshot(): void {
  projectListSnapshot = null;
}
